import React, {useEffect} from 'react';
import shepherdDemo from '../assets/shepherd-demo.mp4';

// Notice: No 'useState' inside this file. 
// This component only shows up when the Footer says so.
export default function DemoVid({ close }) {

    useEffect(() => {
        // 1. Lock scrolling when modal opens
        document.body.style.overflow = 'hidden';

        // 2. Clean up: Unlock scrolling when modal closes
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);

    return (
        <div style={styles.container} onClick={close}>
            <video 
                style={styles.video} 
                controls 
                autoPlay 
                loop
                onClick={(e) => e.stopPropagation()} 
            >
                <source src={shepherdDemo} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </div>
    );
}
       

const styles = {
    container: {
        display: "flex", // Keep this as flex
        alignItems: "center",
        justifyContent: "center",
        position: "fixed", 
        top: 0,
        left: 0,
        width: '100vw',
        border: "4px solid blue",
        height: '100vh',
        backdropFilter: "blur(6px)",
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        zIndex: 9999,
    },
    contextContainer: {
        color: "black",
        display: "flex",
        backdropFilter: "blur(6px)",
        width: "90%",
        maxWidth: "90%",
        height: "80%",
        flexDirection: "column",
        gap: "1rem",
        padding: "2.5rem",
        backgroundColor: 'white',
        borderRadius: "12px",
        position: "relative",
        textAlign: "left",
        boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
    },
    closeBtn: {
        position: "absolute",
        top: "15px",
        right: "15px",
        background: "transparent",
        border: "none",
        fontSize: "1.2rem",
        cursor: "pointer",
        color: "#999",
    },
    scrollableContent: {
        borderTop: "1px solid rgba(0,0,0,0.1)",
        marginTop: "1rem",
        paddingTop: "1rem",
        height: "100%",
        overflowY: "auto",
        textAlign: "left",
        paddingRight: "15px",
    },
    mainTitle: {
        fontSize: "1.8rem",
        marginBottom: "2rem", // Large gap after title
        marginTop: 0,
    },
    section: {
        marginBottom: "2.5rem", // This creates the big space between 1, 2, 3, etc.
    },
    heading: {
        display: "block",      // Makes the bold heading sit on its own line
        marginBottom: "0.8rem", // Space between "1. Introduction" and the text below it
        fontSize: "1.1rem",
    },
    video: {
        width: "80%",
        height: "auto",
        borderRadius: "8px",
        boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
    },
};